export function appButtonsDisabled(status: string): boolean {
  const disabled: Record<string, boolean> = {
    CREATE_IN_PROGRESS: true,
    UPDATE_IN_PROGRESS: true,
    UPDATE_COMPLETE_CLEANUP_IN_PROGRESS: true,
    UPDATE_ROLLBACK_FAILED: true,
    UPDATE_ROLLBACK_IN_PROGRESS: true,
    UPDATE_ROLLBACK_COMPLETE: true,
    UPDATE_ROLLBACK_COMPLETE_CLEANUP_IN_PROGRESS: true,
    DELETE_IN_PROGRESS: true,
    ROLLBACK_IN_PROGRESS: true,
    CREATE_FAILED: true,
    UPDATE_FAILED: true,
    DELETE_FAILED: true,
    ROLLBACK_FAILED: true,
    CREATE_COMPLETE: false,
    UPDATE_COMPLETE: false,
    ROLLBACK_COMPLETE: true,
  };

  return disabled[status];
}

export function updateButtonDisabled(status: string): boolean {
  const disabled: Record<string, boolean> = {
    CREATE_IN_PROGRESS: true,
    UPDATE_IN_PROGRESS: true,
    UPDATE_COMPLETE_CLEANUP_IN_PROGRESS: true,
    UPDATE_ROLLBACK_FAILED: true,
    UPDATE_ROLLBACK_IN_PROGRESS: true,
    UPDATE_ROLLBACK_COMPLETE: true,
    UPDATE_ROLLBACK_COMPLETE_CLEANUP_IN_PROGRESS: true,
    DELETE_IN_PROGRESS: true,
    ROLLBACK_IN_PROGRESS: true,
    CREATE_FAILED: true,
    UPDATE_FAILED: true,
    DELETE_FAILED: true,
    ROLLBACK_FAILED: true,
    CREATE_COMPLETE: false,
    UPDATE_COMPLETE: false,
    ROLLBACK_COMPLETE: true,
  };

  return disabled[status];
}

export function deleteButtonDisabled(status: string): boolean {
  const disabled: Record<string, boolean> = {
    CREATE_IN_PROGRESS: false,
    UPDATE_IN_PROGRESS: false,
    UPDATE_COMPLETE_CLEANUP_IN_PROGRESS: true,
    UPDATE_ROLLBACK_IN_PROGRESS: true,
    UPDATE_ROLLBACK_COMPLETE_CLEANUP_IN_PROGRESS: true,
    DELETE_IN_PROGRESS: true,
    ROLLBACK_IN_PROGRESS: true,
    UPDATE_ROLLBACK_COMPLETE: false,
    UPDATE_ROLLBACK_FAILED: false,
    CREATE_FAILED: false,
    UPDATE_FAILED: false,
    DELETE_FAILED: false,
    ROLLBACK_FAILED: false,
    CREATE_COMPLETE: false,
    UPDATE_COMPLETE: false,
    ROLLBACK_COMPLETE: false,
  };

  return disabled[status];
}
